import { Pipe, PipeTransform } from '@angular/core';
import { fromEvent, merge, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Pipe({
  name: 'symbolCountVisibility',
  standalone: true,
})
export class SymbolCountVisibilityPipe implements PipeTransform {
  public transform(value: HTMLElement): Observable<boolean> {
    return merge(
      fromEvent<Event>(value, 'focus').pipe(map(() => true)),
      fromEvent<Event>(value, 'blur').pipe(map(() => false)),
    ).pipe(startWith(false));
  }
}
